import dayjs from 'dayjs';
import moment from 'moment';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ar from './js/ar';
import de from './js/de';
import en from './js/en';
import es from './js/es';
import esEu from './js/esEu';
import fr from './js/fr';
import id from './js/id';
import it from './js/it';
import pl from './js/pl';
import pt from './js/pt';
import ru from './js/ru';
import th from './js/th';
import tr from './js/tr';
import vi from './js/vi';
import zh from './js/zh';
import ja from './js/ja';

Vue.use(VueI18n);
const language = process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE;
const loadedLanguages = [language];
const messages = {
  ar: {
    ...ar
  },
  de: {
    ...de
  },
  en: {
    ...en
  },
  es: {
    ...es
  },
  fr: {
    ...fr
  },
  id: {
    ...id
  },
  it: {
    ...it
  },
  pl: {
    ...pl
  },
  pt: {
    ...pt
  },
  th: {
    ...th
  },
  tr: {
    ...tr
  },
  vi: {
    ...vi
  },
  ru: {
    ...ru
  },
  zh: {
    ...zh
  },
  cn: {
    ...zh
  },
  esEu: {
    ...esEu
  },
  eseu: {
    ...esEu
  },
  ja: {
    ...ja
  }
};

// 设置vant的语言
const i18n = new VueI18n({
  // 默认语言，这里的local属性，对应message中的zh、en属性
  locale: language,
  // set locale messages
  // 这里的属性名是任意的，您也可以把zh设置为cn等，只是后续切换语言时
  // 要标识这里的语言属性，如：this.$i18n.locale = zh|en|zh|xxx
  messages,
  // 预设的语言环境（相当于默认语言，当前语言翻译不全时，使用预设语言文本）
  fallbackLocale: language,
  silentTranslationWarn: true // 在创建VueI18n实例时，可以添加这行代码配置，关闭waring提示信息。
});

setI18nLanguage(language);

/**
 * 设置vue-i18n语言
 * @param {*} lang
 * @returns
 */
function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);

  if (lang === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl');
    document.querySelector('html').classList.add('is-rtl');
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
    document.querySelector('html').classList.remove('is-rtl');
  }

  if (!['zh', 'cn'].includes(lang)) {
    document.getElementsByTagName('body')[0].className = lang;
  } else {
    document.getElementsByTagName('body')[0].className = '';
  }

  dayjs.locale(lang);
  return lang;
}

/**
 * 加载语言
 * @param {*} lang
 * @returns
 */
export function loadLanguageAsync(lang = language) {
  return new Promise(resolve => {
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import(
          /* webpackChunkName: "lang-[request]" */
          `./js/${lang}`
        )
          .then(msg => {
            const locale = msg.default;

            i18n.setLocaleMessage(lang, locale);
            loadedLanguages.push(lang);
            moment.updateLocale(locale.momentName, locale.momentLocale);
            locale.dayjsLocale && dayjs.locale(locale.dayjsName, locale.dayjsLocale);
            return setI18nLanguage(lang);
          })
          .catch(e => {
            console.log('加载语言包错误', e);
          });
      }
      return resolve(setI18nLanguage(lang));
    }
    return resolve(lang);
  });
}

export default i18n;
